import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllNewPermissionsApi } from "../../Api/permissionApi";
import { mapMenuBarPermissions } from "../Types/NewPermission/MenuBarPermission";

// handle for menubars
export const getAllNewPermissionsThunk = createAsyncThunk(
  "getAllNewPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const permissions = await getAllNewPermissionsApi();

      if (permissions.status) {
        return mapMenuBarPermissions(permissions.body);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(permissions.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all tenderDetails");
    }
  }
);
